<template>
  <b-nav-item @click="skin = isDark ? 'light' : 'dark'">
    <feather-icon
      class="nav-text"
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    />
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
}
</script>

<style scoped>
.nav-text {
    width: 22px;
    height: 22px;
    margin-left: 5px;
    margin-right: 5px;
  }

@media (max-width: 768px) {
  .nav-text {
    width: 12px;
    height: 12px;
  }
}
</style>
